import { render, staticRenderFns } from "./wtTranslateStory.component.vue?vue&type=template&id=2fcc5d84&"
import script from "./wtTranslateStory.component.vue?vue&type=script&lang=js&"
export * from "./wtTranslateStory.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports